import React from 'react';

import { dateToTwoDigitDate } from '@trqk/utils';

interface BMATUploadInstructionsProps {
    performancePeriodEnd: Date | null;
    performancePeriodStart: Date | null;
}

export const BMATUploadInstructions = ({
    performancePeriodEnd,
    performancePeriodStart,
}: BMATUploadInstructionsProps): JSX.Element => {
    const startDateLabel =
        performancePeriodStart !== null
            ? dateToTwoDigitDate(performancePeriodStart)
            : 'your start date';

    const endDateLabel =
        performancePeriodEnd !== null
            ? dateToTwoDigitDate(performancePeriodEnd)
            : 'your end date';

    return (
        <div className="mx-12 text-sm">
            <h5>How to Download BMAT Detections</h5>
            <ol className="list-decimal mx-10 mt-4">
                <li>
                    Log in to your{' '}
                    <a
                        className="respond-to-mouse underline text-primary-500"
                        href="https://vericast.bmat.me/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        BMAT account
                    </a>
                    .
                </li>
                <li>
                    Click <span className="font-semibold">Music Report</span> in
                    the left navigation menu, then click{' '}
                    <span className="font-semibold">View Filter</span> on the
                    top right. Under date interval, enter{' '}
                    <span className="font-semibold">{startDateLabel}</span> in
                    the <span className="italic">From date</span> window. Enter{' '}
                    <span className="font-semibold">{endDateLabel}</span> in the{' '}
                    <span className="italic">To date</span> window.
                </li>
                <li>
                    Click <span className="font-semibold">Apply Filters</span>.
                </li>
                <li>
                    Click <span className="font-semibold">Generate Report</span>{' '}
                    on the top right.
                </li>
                <li>
                    Click{' '}
                    <span className="font-semibold">Advanced Options</span> on
                    the bottom right of the window that pops up. Select{' '}
                    <span className="font-semibold">CSV</span> in the dropdown
                    selector. Click{' '}
                    <span className="font-semibold">Continue</span>. Click{' '}
                    <span className="font-semibold">Generate</span> under{' '}
                    <span className="italic">Download my report</span>.
                </li>
            </ol>
            <p className="mt-4">
                You should see{' '}
                <span className="italic">Creating your report ...</span> Please
                be patient, this might take a while.
            </p>
            <p className="mt-4">
                Be sure to click <span className="font-semibold">Download</span>{' '}
                when the report is finished. When the report has finished
                downloading, upload it here.
            </p>
        </div>
    );
};
